module.exports = __webpack_public_path__ + "assets/images/topo_transparent-b5adfb9e7a476c951dcbff3bf7638a5d.svg";